import { render } from "./upcoming.vue?vue&type=template&id=74927036"
import script from "./upcoming.vue?vue&type=script&lang=js"
export * from "./upcoming.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/widgets/upcoming.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74927036"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74927036', __exports__)) {
    console.log('reload')
    api.reload('74927036', __exports__)
  }
  
  module.hot.accept("./upcoming.vue?vue&type=template&id=74927036", () => {
    console.log('re-render')
    api.rerender('74927036', render)
  })

}


export default __exports__